import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Load Calendly widget script
const calendlyScript = document.createElement('script');
calendlyScript.src = 'https://assets.calendly.com/assets/external/widget.js';
calendlyScript.async = true;
document.head.appendChild(calendlyScript);
render(<App data-id="element-185" data-mp="26alpwhjfajz2" />, document.getElementById('root'));